import { useMutation, useQueryClient } from '@tanstack/vue-query'

export const useLogoutMutation = () => {
  const queryClient = useQueryClient()
  const app = useNuxtApp()

  return useMutation({
    mutationFn: () => app.$api<undefined>('/account/logout'),
    onSuccess() {
      queryClient.clear()
    },
  })
}
